import Layout from "../../../../src/contents/sequenceDiagram/Layout";
import SEO from "../../../../src/components/seo";
import { Link } from 'gatsby';
import React from 'react';
export default {
  Layout,
  SEO,
  Link,
  React
};